import Statistics from 'Statistics/Statistics';
import SplashScreen from 'components/SplashScreen';
import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import WalletProtectedRoutes from './WalletRouter/WalletProtectedRoutes';
// import KalaCard from 'pages/KalaCrd';
import NotKalaCard from 'pages/KalaCrd/NotKalaCard';
import DetailInstallment from 'pages/Installments/Mahsa';
import PaymentInvoice from 'pages/Installments/Mahsa/PaymentInvoice';
const WalletRouting = React.lazy(() => import('pages/Wallets'));
const Home = React.lazy(() => import('pages/Home/Home'));
const Rules = React.lazy(() => import('pages/Rules/Rules'));
const LayoutLogin = React.lazy(() => import('pages/Auth/LayoytLogin'));

const Faq = React.lazy(() => import('pages/Profile/Faq'));
const PayOperation = React.lazy(() =>
	import('pages/WalletMehr-NewFlow/Pages/Payfortheoperation/PayOperation'),
);
const WalletRequestPage = React.lazy(() => import('pages/WalletMehr-NewFlow'));
const Messages = React.lazy(() => import('pages/Messages/Messages'));
const Stores = React.lazy(() => import('pages/Stores/Stores'));
const StoreDetails = React.lazy(() => import('pages/StoreDetail/StoreDetails'));
const Transactions = React.lazy(() => import('pages/Transactions/Transactions'));
const PersonalInfo = React.lazy(() => import('pages/PersonalInfo/PersonalInfo'));
const StoreCategory = React.lazy(() => import('pages/StoreCategory/StoreCategory'));
const ViewInstallments = React.lazy(() => import('pages/ViewInstallments/ViewInstallments'));
const Installments = React.lazy(() => import('pages/Installments'));
const CreditInstallmentsDetails = React.lazy(() =>
	import('pages/Installments/Details/CreditInstallmentsDetails'),
);
const Profile = React.lazy(() => import('pages/Profile/Profile'));

const Router = () => {
	return (
		<Routes>
			<Route
				element={
					<React.Suspense fallback={<SplashScreen />}>
						<LayoutLogin />
					</React.Suspense>
				}
				path="/auth/login"
			/>
			<Route
				element={
					<React.Suspense fallback={<SplashScreen />}>
						<Statistics />
					</React.Suspense>
				}
				path="/wallet/report"
			/>
			<Route
				element={
					<React.Suspense fallback={<SplashScreen />}>
						<Rules />
					</React.Suspense>
				}
				path="/rules"
			/>
			<Route
				element={
					<PrivateRoute>
						<React.Suspense fallback={<SplashScreen />}>
							<Home />
						</React.Suspense>
					</PrivateRoute>
				}
				path="/home"
			/>
			{/* TODO:chnage route */}

			<Route
				element={
					<PrivateRoute>
						<React.Suspense fallback={<SplashScreen />}>
							<NotKalaCard />
						</React.Suspense>
					</PrivateRoute>
				}
				path="/kalacrd"
			/>
			{/* //////////////// */}
			{/* <Route
				element={
					<PrivateRoute>
						<React.Suspense fallback={<SplashScreen />}>
							<PromissoryNoteReceipt />
						</React.Suspense>
					</PrivateRoute>
				}
				path="/promissoryNote/receipt/:id"
			/> */}
			<Route
				element={
					<PrivateRoute>
						<React.Suspense fallback={<SplashScreen />}>
							<Transactions />
						</React.Suspense>
					</PrivateRoute>
				}
				path="/transactions"
			/>
			<Route
				element={
					<PrivateRoute>
						<React.Suspense fallback={<SplashScreen />}>
							<ViewInstallments />
						</React.Suspense>
					</PrivateRoute>
				}
				path="/transactions/details"
			/>
			<Route
				element={
					<PrivateRoute>
						<React.Suspense fallback={<SplashScreen />}>
							<Installments />
						</React.Suspense>
					</PrivateRoute>
				}
				path="/installments"
			/>
			<Route
				element={
					<PrivateRoute>
						<React.Suspense fallback={<SplashScreen />}>
							<CreditInstallmentsDetails />
						</React.Suspense>
					</PrivateRoute>
				}
				path="/installments/details"
			/>
			<Route
				element={
					<PrivateRoute>
						<React.Suspense fallback={<SplashScreen />}>
							<Profile />
						</React.Suspense>
					</PrivateRoute>
				}
				path="/profile"
			/>
			<Route
				element={
					<PrivateRoute>
						<React.Suspense fallback={<SplashScreen />}>
							<PersonalInfo />
						</React.Suspense>
					</PrivateRoute>
				}
				path="/profile/personalinfo"
			/>
			<Route
				element={
					<PrivateRoute>
						<React.Suspense fallback={<SplashScreen />}>
							<Faq />
						</React.Suspense>
					</PrivateRoute>
				}
				path="/profile/faq"
			/>
			<Route
				element={
					<PrivateRoute>
						<React.Suspense fallback={<SplashScreen />}>
							<StoreDetails />
						</React.Suspense>
					</PrivateRoute>
				}
				path="/stores/detail/:id"
			/>
			<Route
				element={
					<PrivateRoute>
						<React.Suspense fallback={<SplashScreen />}>
							<Stores />
						</React.Suspense>
					</PrivateRoute>
				}
				path="/stores"
			/>
			<Route
				element={
					<PrivateRoute>
						<React.Suspense fallback={<SplashScreen />}>
							<StoreCategory />
						</React.Suspense>
					</PrivateRoute>
				}
				path="/store/category/:id"
			/>

			<Route
				element={
					<PrivateRoute>
						<React.Suspense fallback={<SplashScreen />}>
							<Messages />
						</React.Suspense>
					</PrivateRoute>
				}
				path="/messages"
			/>

			<Route
				element={
					<PrivateRoute>
						<React.Suspense fallback={<SplashScreen />}>
							<PayOperation />
						</React.Suspense>
					</PrivateRoute>
				}
				path="/payoperation"
			/>

			<Route
				element={
					<PrivateRoute>
						<React.Suspense fallback={<SplashScreen />}>
							<WalletRouting />
						</React.Suspense>
					</PrivateRoute>
				}
				path="/wallet/*"
				index
			/>
			<Route
				element={
					<PrivateRoute>
						<React.Suspense fallback={<SplashScreen />}>
							<DetailInstallment />
						</React.Suspense>
					</PrivateRoute>
				}
				path="/detailinstallment"
				index
			/>
			<Route
				element={
					<PrivateRoute>
						<React.Suspense fallback={<SplashScreen />}>
							<PaymentInvoice />
						</React.Suspense>
					</PrivateRoute>
				}
				path="/paymentinvoice"
				index
			/>

			<Route
				path="walletrequest"
				element={
					<PrivateRoute>
						<WalletProtectedRoutes>
							<React.Suspense fallback={<SplashScreen />}>
								<WalletRequestPage />
							</React.Suspense>
						</WalletProtectedRoutes>
					</PrivateRoute>
				}
			>
				<Route
					path="*"
					element={
						<PrivateRoute>
							<WalletProtectedRoutes>
								<React.Suspense fallback={<SplashScreen />}>
									<WalletRequestPage />
								</React.Suspense>
							</WalletProtectedRoutes>
						</PrivateRoute>
					}
				/>

				<Route
					path="document"
					element={
						<PrivateRoute>
							<WalletProtectedRoutes>
								<React.Suspense fallback={<SplashScreen />}>
									<WalletRequestPage />
								</React.Suspense>
							</WalletProtectedRoutes>
						</PrivateRoute>
					}
				>
					<Route
						path=":documentid"
						element={
							<PrivateRoute>
								<WalletProtectedRoutes>
									<React.Suspense fallback={<SplashScreen />}>
										<WalletRequestPage />
									</React.Suspense>
								</WalletProtectedRoutes>
							</PrivateRoute>
						}
					/>
				</Route>
			</Route>
			<Route path="/" element={<Navigate to="/home" />} />
		</Routes>
	);
};

export default Router;
